module.exports = __webpack_public_path__ + "src/assets/textures/molar/table_w_cap_lambert11_AO.jpg";